/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const TooltipCustom = ({ tipId, displayData, placement }) => {
  const [portActivityOpen, setPortActivityOpen] = useState(false);

  const toggle = () => setPortActivityOpen(!portActivityOpen);

  return (
    <>
      <Tooltip
        delay={0}
        placement={placement}
        isOpen={portActivityOpen}
        target={tipId}
        toggle={toggle}
      >
        {displayData}
      </Tooltip>
    </>
  );
};

export default TooltipCustom;
